import styled from 'styled-components'
import { theme } from '@provi/provi-components'

export const View = styled.div`
  width: ${({ width }) => width || '300'}px !important;

  ${theme.breakpoints.down('md')} {
    width: 100%;
  }
`
